module.exports = __webpack_public_path__ + "resources/img/g-talk-club.82f3a9c0.svg";